/* global localData */
const radios = document.querySelectorAll('.winner-card-list input[type=radio][name="archive_year"]');
if (radios) {
  radios.forEach((radio) => radio.addEventListener('change', () => {
    const ajax = new XMLHttpRequest();
    const formInfo = new FormData();
    formInfo.append('action', 'getArchiveForYear');
    formInfo.append('year', radio.value);
    ajax.open('POST', localData.siteURL, true);
    ajax.onload = function () {
      const response = JSON.parse(ajax.responseText);
      let html = '';
      if (response.data.hackatons) {
        response.data.hackatons.forEach((item) => {
          let htmlWinners = '';
          item.winner_card.winner_list_items.forEach((winner) => {
            htmlWinners += `<li>${winner.text}</li>`;
          });
          let htmlTitle = '';
          if (htmlWinners) {
            htmlTitle = `<div class="winner-card__winner-list-header : title--h6">
                <i class="icon : icon-prize"></i>
                <h3>${item.winner_card.winner_list_title}</h3>
              </div>`;
          }
          let htmlIcons = '';
          item.winner_card.icon_text.items.forEach((icon) => {
            htmlIcons += `<div class="icon-text__item">
                        <div class="icon-text__icon : d-flex-cc">
                          <img src="${icon.image_src}" alt="${icon.image_alt}" width="50" height="50">
                        </div>
                        <div class="icon-text__text">
                          <p>
                            <span>${icon.title}</span><br><strong>${icon.text}</strong>
                          </p>
                        </div>
                      </div>`;
          });
          let htmlSponsor = '';
          if (item.winner_card.sponsor_card.text) {
            htmlSponsor += `<a href="${item.winner_card.sponsor_card.href}" class="sponsor-card"><article class="sponsor-card">
              <p>${item.winner_card.sponsor_card.text}</p>
              <div class="sponsor-card__image : d-flex-cc">
                <img width="90" src="${item.winner_card.sponsor_card.image_src}" data-src="${item.winner_card.sponsor_card.image_src}" alt="${item.winner_card.sponsor_card.image_alt}">
              </div>
              </article></a>`;
          }
          html += `<article class="winner-card">
            <div class="winner-card__inner">
              <div class="winner-card__image-wrapper">
              <div class="winner-card__image">
                <div class="image-aspect : image-aspect--cover">
                  <div class="image-aspect__bg" data-responsive="responsive-bg-image" style="background-image: url(${item.winner_card.image_src});">
                    <img class="responsive-bg-img" src="${item.winner_card.image_src}" alt="${item.winner_card.image_alt}">
                  </div>
                </div>
              </div>
                ${htmlSponsor}
              </div>
              <div class="winner-card__content">
                <div class="title : title--h2">
                  <h2>${item.winner_card.title}</h2>
                </div>
                <div class="winner-card__content-inner">
                  <div class="winner-card__content-left">
                    <div class="body-text : body-text--14">${item.winner_card.text}</div>
                    <div class="winner-card__winner-list">
                      ${htmlTitle}
                      <ol>
                        ${htmlWinners}
                      </ol>
                    </div>
                  </div>
                  <div class="winner-card__content-right">
                    <div class="icon-text">
                      ${htmlIcons}
                    </div>
                  </div>
                  <div class="winner-card__content-footer">
                    <a class="btn : btn--blue" href="${item.winner_card.button_href}"><span class="btn__text">${item.winner_card.button_text}</span></a></div>
                </div>
              </div>
            </div>
          </article>`;
        });
      }
      document.querySelector('.winner-card-box').innerHTML = html;
    };
    ajax.send(formInfo);
  }));
}
